<input
  #stringInput
  autocomplete="off"
  data-lpignore="true"
  [type]="secureFieldType"
  [formControl]="formControl"
  class="string-input"
  (beforeinput)="secureFieldInputBeforeInputFn($event, formControl)"
  (focus)="secureFieldTypeFocusFn($event, stringInput)"
  (click)="secureFieldTypeFocusFn($event, stringInput)"
/>
@if (formControl.dirty) {
  <button (click)="changeSecureTextType()" blazeIconButton class="password-icon">
    <mat-icon svgIcon="icon_preview_16" [class.!hidden]="secureFieldType === 'text'" />
    <mat-icon svgIcon="icon_preview_hidden_16" [class.!hidden]="secureFieldType === 'password'" />
  </button>
}
